import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import symbolLogo from "../assets/logo/logo_transparent.png";
import { UserContext } from "./UserContext";

export default function Footer() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { user } = useContext(UserContext);

  // Hide footer on specific URL
  if (
    location.pathname === "/account" &&
    searchParams.get("mode") === "host" &&
    searchParams.get("section") === "addWorkspace"
  ) {
    return null;
  }

  return (
    <footer className="bg-[var(--secondary)] text-white mx-auto w-full items-center">
      <div className="container mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-8 mb-8">
          {/* Left Section - Logo */}
          <div className="lg:w-48">
            <img
              src={symbolLogo}
              alt="AirArrange Symbol"
              className="h-16 w-auto"
            />
          </div>

          {/* Center Section - Three Columns */}
          <div className="flex-1 flex justify-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-16 gap-y-8 w-full max-w-5xl">
              {/* Company Info */}
              <div>
                <h3 className="font-semibold text-lg mb-4">About AirArrange</h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/workspaces"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Browse workspaces
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/aboutUs"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      About us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/solutions"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Solutions
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/gift-cards"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Gift cards
                    </Link>
                  </li> */}
                  {/*<li>*/}
                  {/*  <Link*/}
                  {/*    to="/careers"*/}
                  {/*    className="text-gray-300 hover:text-white transition-colors"*/}
                  {/*  >*/}
                  {/*    Careers*/}
                  {/*  </Link>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  <Link*/}
                  {/*    to="/press"*/}
                  {/*    className="text-gray-300 hover:text-white transition-colors"*/}
                  {/*  >*/}
                  {/*    Press*/}
                  {/*  </Link>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  <Link*/}
                  {/*    to="/blog"*/}
                  {/*    className="text-gray-300 hover:text-white transition-colors"*/}
                  {/*  >*/}
                  {/*    Blog*/}
                  {/*  </Link>*/}
                  {/*</li>*/}
                </ul>
              </div>

              {/* Support */}
              <div>
                <h3 className="font-semibold text-lg mb-4">Support</h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/help"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Help Centre
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contactUs"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Contact us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/trust-and-safety"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Trust & Safety
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/cancellation-refund"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Cancellation & Refunds
                    </Link>
                  </li> */}
                </ul>
              </div>

              {/* Hosting */}
              <div>
                <h3 className="font-semibold text-lg mb-4">Hosting</h3>
                <ul className="space-y-2">
                  {user && (
                    <li>
                      <Link
                        to="/account?mode=host&section=addWorkspace"
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        List your workspace
                      </Link>
                    </li>
                  )}
                  {/* <li>
                    <Link
                      to="/hosting-resources"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Hosting resources
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/community"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Community forum
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/host-responsibilities"
                      className="text-gray-300 hover:text-white transition-colors"
                    >
                      Hosting responsibly
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Section - Social Media */}
          {/*
          <div className="lg:ml-auto">
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
          */}
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-300 text-sm">
            © 2026 AirArrange. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link
              to="/privacy-policy"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-500">·</span>
            <Link
              to="/terms-of-service"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            <span className="text-gray-500">·</span>
            <Link
              to="/sitemap"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Sitemap
            </Link>
            <span className="text-gray-500">·</span>
            <Link
              to="/company-details"
              className="text-gray-300 hover:text-white transition-colors"
            >
              Company details
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
